/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED REACT QUERY HOOKS - DO NOT EDIT
 * Generated from: MerchantProfileContract
 */

import { merchantprofileApi } from '../api/merchantprofile.api';
import { createMessageMutationHook, createQueryHook } from './base.hooks';
import { queryKeys } from './query-keys';
import type { GetMerchantProfileParamsType, GetMerchantProfileResponseType, UpdateMerchantProfileBodyType, UpdateMerchantProfileParamsType, UpdateMerchantProfileResponseType } from '@zlinkx/shared-v2';
import type { HookOptions, MutationHookReturn, QueryHookReturn } from '@/types/hook-generated.types';

export const useGetMerchantProfile = createQueryHook<GetMerchantProfileResponseType['data'], { merchantId: GetMerchantProfileParamsType['merchantId'] }>(
  ({ merchantId }) => merchantprofileApi.getMerchantProfile(merchantId),
  ({ merchantId }) => queryKeys.merchantprofile.getMerchantProfile(merchantId)
);

export const useUpdateMerchantProfile = createMessageMutationHook<{ merchantId: UpdateMerchantProfileParamsType['merchantId']; data: UpdateMerchantProfileBodyType }>(
  (params) => merchantprofileApi.updateMerchantProfile(params.merchantId, params.data),
  {
    queryKey: queryKeys.merchantprofile.all,
  }
);